import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Dictionary", -1)
const _hoisted_3 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mr-auto" }, null, -1)
const _hoisted_13 = { class: "ml-auto text-light" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)

import { inject, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';



export default /*#__PURE__*/_defineComponent({
  __name: 'Dictionary',
  setup(__props) {

const store = useStore();
const route = useRoute();
const toasted = useToast();

const tab = ref(route.params.tab);
const actProperty: any = inject('actProperty');

const addDictionary = (queryStringParameters: {
    reorder: boolean;
  }) => {
  return store.dispatch('dictionary/addDictionary', queryStringParameters);
};

onMounted(async () => {
  tab.value = route.params.tab;
});

const saveDictionary = async (reorder: boolean) => {
  let confirm;

  if (reorder) {
    confirm = actProperty.confirmPrompt(
      "Are you sure you want to reorder?"
    );
  } else {
    confirm = new Promise((resolve, reject) => resolve(true));
  }

  confirm
    .then(() => addDictionary({ reorder }))
    .then(() => toasted.success(`Saved`))
    .catch((err: any) => actProperty.displayError(err));
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "items",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Items ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "conditions",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Condition Matrix ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "templates",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Templates ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "reporttypes",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Report Types ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "systemsetting",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" System Setting ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "fixflo",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Fixflo ")
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "btn btn-outline-light",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (saveDictionary(true)), ["prevent"]))
          }, [
            _hoisted_14,
            _createTextVNode(" Save and Reorder ")
          ]),
          _createTextVNode("   "),
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (saveDictionary(false)), ["prevent"]))
          }, [
            _hoisted_15,
            _createTextVNode(" Save ")
          ])
        ])
      ])
    ])
  ]))
}
}

})